import SockJS from "sockjs-client";
import Stomp from "webstomp-client";
import notificationSound from '../assets/sounds/notification.mp3'

export default {
  data() {
    return {
      send_message: null,
      connected: false,
      isConnecting: false,
      intentionalDisconnect: false,
      pending: sessionStorage.getItem("notification") ?? 0,
      socket: null,
      stompClient: null,
      retryCount: 0,
      maxRetries: 5,
    };
  },

  methods: {
    setPending() {
      if (this.pending === null || this.pending === 0) {
        this.pending = 1;
      } else {
        this.pending++;
      }
      sessionStorage.setItem("notification", this.pending);
    },
    send(msgTxt) {
      this.send_message = msgTxt;
      if (this.stompClient && this.stompClient.connected) {
        const msg = { name: this.send_message };
        this.stompClient.send("/app/hello", JSON.stringify(msg), {});
      }
    },
    connect() {
      const zetrixAccount = sessionStorage.getItem("zetrixAccount");

      if (!zetrixAccount) {
        console.log("WebSocket: no zetrixAccount in session, skipping connect");
        return;
      }

      if (this.isConnecting || this.connected) {
        return;
      }

      this.intentionalDisconnect = false;
      this.isConnecting = true;
      this.socket = new SockJS(process.env.VUE_APP_WS_URL);
      this.stompClient = Stomp.over(this.socket);
      this.stompClient.connect(
        { appPrefix: "multisig", subscriberId: zetrixAccount },
        (frame) => {
          if (this.intentionalDisconnect) return;
          this.isConnecting = false;
          this.connected = true;
          this.retryCount = 0;
          this.stompClient.subscribe("/user/queue/notifications", (tick) => {
            var notification = JSON.parse(tick.body);
            // Only play sound for new (unseen) notifications, not for "marked as seen" updates
            if (!notification.seen) {
              // this.setPending();
              var audio = new Audio(notificationSound);
              audio.play();
              setTimeout(() => {
                this.receivedNoti = false;
              }, 5000);
            }
          });
        },
        (error) => {
          console.error("WebSocket error:", error.message || error);
          this.isConnecting = false;
          this.connected = false;
          if (!this.intentionalDisconnect && this.retryCount < this.maxRetries) {
            const delay = Math.min(1000 * Math.pow(2, this.retryCount), 30000);
            this.retryCount++;
            setTimeout(() => this.connect(), delay);
          }
        }
      );
    },
    disconnect() {
      this.intentionalDisconnect = true;
      this.isConnecting = false;
      this.connected = false;
      if (this.stompClient && this.stompClient.connected) {
        this.stompClient.disconnect();
      } else if (this.socket) {
        this.socket.close();
      }
    },
    tickleConnection() {
      this.connected ? this.disconnect() : this.connect();
    },
  },
};
